import React from 'react'
import QuestionCard from './QuestionCard'
import RadioOption from './RadioOption'

interface SectionProps {
  formData: Record<string, any>
  updateField: (field: string, value: any) => void
}

/**
 * Section C — Non-AI users (Q9-Q10).
 * Shown only to respondents who answered q5 === 'nao_usamos'.
 * Explores reasons for not using AI and what would change their mind.
 */
const SectionC: React.FC<SectionProps> = ({ formData, updateField }) => {
  return (
    <div className="flex flex-col gap-6">
      {/* Q9 — Motivo de não usar IA */}
      <QuestionCard
        title="Qual o principal motivo de não usar IA na operação?"
        required
      >
        <RadioOption
          name="q9"
          value="sem_aplicacao"
          label="Não vejo aplicação clara para o meu negócio"
          selected={formData.q9 === 'sem_aplicacao'}
          onChange={(v) => updateField('q9', v)}
        />
        <RadioOption
          name="q9"
          value="falta_conhecimento"
          label="Falta de conhecimento da equipe"
          selected={formData.q9 === 'falta_conhecimento'}
          onChange={(v) => updateField('q9', v)}
        />
        <RadioOption
          name="q9"
          value="custo"
          label="Custo das ferramentas"
          selected={formData.q9 === 'custo'}
          onChange={(v) => updateField('q9', v)}
        />
        <RadioOption
          name="q9"
          value="qualidade"
          label="Preocupação com qualidade / confiança nos resultados"
          selected={formData.q9 === 'qualidade'}
          onChange={(v) => updateField('q9', v)}
        />
        <RadioOption
          name="q9"
          value="falta_tempo"
          label="Falta de tempo para implementar"
          selected={formData.q9 === 'falta_tempo'}
          onChange={(v) => updateField('q9', v)}
        />
        <RadioOption
          name="q9"
          value="ja_tentamos"
          label="Já tentamos e não funcionou"
          selected={formData.q9 === 'ja_tentamos'}
          onChange={(v) => updateField('q9', v)}
        />
        <RadioOption
          name="q9"
          value="outro"
          label="Outro"
          selected={formData.q9 === 'outro'}
          onChange={(v) => updateField('q9', v)}
          hasOtherField
          otherValue={formData.q9_other || ''}
          onOtherChange={(v) => updateField('q9_other', v)}
        />
      </QuestionCard>

      {/* Q10 — O que faria começar a usar IA */}
      <QuestionCard title="O que te faria começar a usar IA?" required>
        <RadioOption
          name="q10"
          value="ver_casos_reais"
          label="Ver casos reais de empresas parecidas com a minha"
          selected={formData.q10 === 'ver_casos_reais'}
          onChange={(v) => updateField('q10', v)}
        />
        <RadioOption
          name="q10"
          value="ferramenta_facil"
          label="Ter uma ferramenta fácil de usar, integrada ao meu sistema"
          selected={formData.q10 === 'ferramenta_facil'}
          onChange={(v) => updateField('q10', v)}
        />
        <RadioOption
          name="q10"
          value="alguem_equipe"
          label="Ter alguém na equipe que entende de IA"
          selected={formData.q10 === 'alguem_equipe'}
          onChange={(v) => updateField('q10', v)}
        />
        <RadioOption
          name="q10"
          value="roi_comprovado"
          label="Ver ROI comprovado"
          selected={formData.q10 === 'roi_comprovado'}
          onChange={(v) => updateField('q10', v)}
        />
        <RadioOption
          name="q10"
          value="nada"
          label="Nada, não acredito que IA seja relevante para minha operação"
          selected={formData.q10 === 'nada'}
          onChange={(v) => updateField('q10', v)}
        />
      </QuestionCard>
    </div>
  )
}

export default SectionC
